<template>
  <div>
    <ClientOnly>
      <div
        v-if="keyFacts && keyFacts.length"
        class="absolute w-full left-0 bg-EXPONDO-primary/90 text-EXPONDO-white z-10
        top-full group-hover:top-[calc(100%-420px)] h-[420px] pt-11 transition-top duration-300 group-hover:delay-300"
      >
        <SimpleLink :to="link">
          <ul class="list-disc pl-12 pr-6 leading-6">
            <li
              v-for="keyFact in keyFacts"
              :key="keyFact"
            >
              {{ keyFact }}
            </li>
          </ul>
        </SimpleLink>
      </div>
    </ClientOnly>
  </div>
</template>
<script lang="ts">

export default defineComponent({
  name: 'ProductCardOverlay',
  props: {
    keyFacts: {
      type: Array as PropType<string[]>,
      default: () => [],
    },
    link: {
      type: String,
      required: true,
    },
  },
});

</script>
